import { render, staticRenderFns } from "./WizardSettingsStep.vue?vue&type=template&id=058764bb&"
import script from "./WizardSettingsStep.vue?vue&type=script&lang=js&"
export * from "./WizardSettingsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('058764bb')) {
      api.createRecord('058764bb', component.options)
    } else {
      api.reload('058764bb', component.options)
    }
    module.hot.accept("./WizardSettingsStep.vue?vue&type=template&id=058764bb&", function () {
      api.rerender('058764bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/WizardSettingsStep.vue"
export default component.exports